import * as yup from 'yup';

export default yup.object().shape({
  profile: yup
    .object()
    .shape({
      firstName: yup.string().required(),
      lastName: yup.string().required(),
      username: yup.string().required(),
      password: yup.string().required(),
      region: yup.string().required(),
      phone: yup.string().required(),
      address: yup.string().required(),
    })
    .required(),
});
